import { Component, Inject } from '@angular/core';
import { PopupService } from '../../shared/services/popup.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-popup',
  standalone: true,
  imports: [],
  templateUrl: './custom-popup.component.html',
  styleUrl: './custom-popup.component.scss'
})
export class CustomPopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private popupService: PopupService
  ) {
  }

  closePopup() {
    this.popupService.closePopup();
  }
}
